import { useFetch } from "@/hooks/useFetch";
import { fetchGithubForProject } from "components/project/integration/api";

export const useGithubData = (id) => {
  const { data: githubData } = useFetch({
    queryKey: ["project-github-integrations", id],
    queryFn: () => fetchGithubForProject({ id: id }),
  });
  const githubRepos = Array.isArray(githubData)
    ? githubData
        .map((entry) => ({
          project_service_id: entry?.id,
          repository_url: entry?.item?.repository_url,
          suffix: entry?.item?.suffix,
          repo_id: entry?.item?.id,
        }))
        .filter((repo) => Boolean(repo.repository_url))
    : [];

  return {
    githubData,
    githubRepos,
  };
};
